import { EditAction } from '../shared/enum/EditAction';
import { ExtraParameterFieldType } from '../shared/enum/ExtraParameterFieldType';

export interface ExtraParameterModel {
    id: number,
    codeMetric: number | null,
    clientId: number,
    description: string,
    type: ExtraParameterFieldType | null,
    answers: string | null,
    active: boolean,
    editAction: EditAction,
    value?: string,
    addedAfterCategorization?: boolean
}

export const extraParameterModelInitial: ExtraParameterModel = {
    id: 0,
    codeMetric: null,
    clientId: 0,
    description: '',
    type: null,
    answers: '',
    active: false,
    editAction: EditAction.NONE
};